import { GridItem, LayoutGrid } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import type { HTMLProps, PropsWithChildren, ReactNode } from 'react';

export interface FullScreenHeroProps extends HTMLProps<HTMLDivElement> {
  readonly Background: () => ReactNode;
  readonly inset?: boolean;
}

const FullScreenHero = ({
  Background,
  children,
  className,
  inset = true,
  ...props
}: PropsWithChildren<FullScreenHeroProps>) => {
  return (
    <section
      data-cy="full-screen-hero"
      {...props}
      className={cx('h-svh overflow-hidden', className)}
    >
      <div
        className={cx('flex size-full', {
          'lg:px-6 lg:pb-6': inset,
        })}
      >
        <div
          className={cx('grid w-full gap-y-0 overflow-hidden', {
            'lg:rounded-b-xl': inset,
          })}
        >
          <div className="relative z-0 col-span-full row-span-full">
            <Background />
          </div>
          <div className="relative z-[1] col-span-full row-span-full">
            <LayoutGrid rowGap={0}>
              <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
                {children}
              </GridItem>
            </LayoutGrid>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FullScreenHero;
